<template>
  <div>
    <el-dialog
      title="批量匹配选择"
      width="700px"
      :close-on-click-modal="false"
      :visible.sync="visible"
      :before-close="handleClose">
      <p class="import-tips">{{ tip }}</p>
      <div class="import-dialog-container">
        <div class="upload-wrapper">
          <p style="color:#4B380E;font-weight:bold;margin-right:10px;">选择匹配文件：</p>
          <div class="button-input-file-wrapper">
            <el-button
              type="primary"
              class="button-input-file">
              {{ fileName }}
            </el-button>
            <input type="file" ref="fileInput" class="file-input" @change="handleChange">
          </div>
        </div>
        <a class="import-model model-link" :href="modelLink" target="_blank">下载模板文件</a>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="success" :disabled="submitDiabled" @click="submitUpload" :loading="submitLoading">匹配选择</el-button>
        <el-button type="info" @click="cancelDialog">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="未匹配老师"
      width="700px"
      class="un-match-dialog"
      :close-on-click-modal="false"
      :visible.sync="showUnMathcVisible"
      :before-close="handleUnMathcClose">
      <div>
        <el-table
          ref="table"
          :data="unMathList"
          tooltip-effect="dark"
          :max-height='maxHeight'
          stripe>
          <el-table-column
            label="老师名称"
            align='center'
            prop='name'>
          </el-table-column>
          <el-table-column
            label="电话"
            align='center'
            prop='phone'>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleUnMathcClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { upLoadTeachers, matchTeachers } from '@/model/exam-manager-model'
import TemplateDictionary from '@/util/template-dictionary'

export default {
  name: 'ImportTeacherDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    schoolId: {
      type: String,
      required: false
    },
    examId: {
      type: String,
      required: true
    },
    subjectId: {
      type: String,
      required: true
    },
    userId: {
      type: String,
      required: true
    },
    dispatchType: {
      type: String,
      required: true
    },
    importType: {
      type: String,
      required: true
    },
    divId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      submitLoading: false,
      file: {},
      fileName: '点击选择文件',
      submitDiabled: true,
      showUnMathcVisible: false,
      maxHeight: 500,
      unMathList: []
    }
  },
  computed: {
    modelLink () {
      if (this.importType === 'leaderOrItem') {
        return TemplateDictionary.matchTeachersPath
      } else {
        return TemplateDictionary.subjectMatchTeachersPath
      }
    },
    uploadQuery () {
      return 'examId=' + this.examId + '&subjectId=' + this.subjectId +
              '&userId=' + this.userId + '&divId=' + this.divId + '&dispatchType=' +
              this.dispatchType + '&schoolId=' + this.schoolId
    },
    matchTeachersQuery () {
      return 'examId=' + this.examId + '&subjectId=' + this.subjectId + '&userId=' + this.userId
    },
    tip () {
      return this.importType === 'leaderOrItem' ? '我们通过姓名、手机号进行快速批量匹配选择。' : '我们通过题号、姓名、手机号进行快速批量匹配选择。'
    }
  },
  created() {
    this.maxHeight = document.body.clientHeight * 0.86 - 200
  },
  methods: {
    checkFile (file) {
      // 必须要是 excel 文件
      let isExcelFile = /\.xlsx?$/.test(file.name)
      // 必须小于 5M
      let isLessThen5M = file.size / 1024 / 1024 < 5

      if (!isExcelFile) {
        this.$message({
          type: 'warning',
          message: '上传文件只能是 Excel 文件(.xls 或 .xlsx 文件)',
          duration: 5000
        })
      } else {
        if (!isLessThen5M) {
          this.$message({
            type: 'warning',
            message: '上传文件大小不能超过 5M',
            duration: 5000
          })
        }
      }
      return isExcelFile && isLessThen5M
    },
    initData () {
      this.submitLoading = false
      this.file = {}
      this.fileName = '点击选择文件'
      this.submitDiabled = true
    },
    /**
     * 导入错误提示(该方法后期要封装)
     * @author wangk 2018-04-18T17:04:51+0800
     * @param  {String} link 错误文档链接
     * @return {[type]}      [description]
     */
    alertImportError (errorMsg, errorFileLink) {
      const h = this.$createElement
      let tipEls = [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--warning`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--warning']
        }, errorMsg)
      ]
      if (errorFileLink) {
        tipEls.push(
          h('a', {
            attrs: {
              href: errorFileLink,
              target: '_blank'
            },
            style: {
              color: '#FF6501',
              outline: 'none'
            }
          }, '下载问题文档')
        )
      }
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, tipEls)
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        confirmButtonClass: 'kw-alert__confirm-button kw-alert__confirm-button--success'
      })
    },
    // 该方法后期要封装
    alertImportSuccess (importedTotal) {
      const h = this.$createElement
      let vnode = h('div', {
        'class': ['kw-alert__wrapper']
      }, [
        h('div', {
          'class': ['kw-alert__icon', `kw-alert__icon--success`]
        }, ''),
        h('p', {
          'class': ['kw-alert__tips', 'kw-alert__tips--success']
        }, `导入成功，已批量匹配选择 ${importedTotal} 人。`)
      ])
      this.$alert(vnode, '', {
        confirmButtonText: '我知道了',
        center: true,
        showClose: false,
        showCancelButton: false,
        callback: action => {
          this.cancelDialog()
          this.$emit('import-success')
        }
      })
    },
    handleChange () {
      let file = this.$refs.fileInput.files[0]
      this.file = file
      this.fileName = file.name
      if (this.checkFile(file)) {
        this.submitDiabled = false
      } else {
        this.submitDiabled = true
      }
    },
    resetForm () {
      this.$refs.fileInput.value = ''
      this.fileName = '点击选择文件'
    },
    submitUpload () {
      if (typeof this.file.name === 'undefined') {
        this.alertImportError('文件为空', null)
        return
      }
      // this.alertImportError()
      this.submitLoading = true
      // this.$refs.importUpload.submit()
      let formData = new FormData()
      formData.append('file', this.file)
      this.unMathList = []
      if (this.importType === 'leaderOrItem') {
        upLoadTeachers({
          query: this.uploadQuery,
          formData
        }).then(res => {
          this.submitLoading = false
          let data = res.data
          if (res.result === 'true') {
            console.log('导入成功')
            // 导入成功
            this.alertImportSuccess(res.data.total)
            this.$emit('push-imported-teachers', res.data.teachers)
          } else if (res.result === 'false' && res.data.teachers.length > 0) {
            // 导入失败
            // this.alertImportError('已批量匹配选择了一些教师，还有一些教师没有匹配上！', data.path)
            this.$confirm('已批量匹配选择了一些教师，还有一些教师没有匹配上！', '温馨提示', {
              confirmButtonText: '确定',
              cancelButtonText: '查看未匹配上的老师',
              type: 'warning'
            }).catch(() => {
              this.unMathList = res.data.notMatchTeachers
              this.showUnMathcVisible = true
            });
            this.$emit('push-imported-teachers', res.data.teachers)
          } else {
            console.log('导入失败')
            if (data) {
            // 导入失败
              this.alertImportError('导入遇到问题，请下载问题文档！', data.path)
            } else {
            // 导入失败
              this.alertImportError(res.errorMsg, null)
            }
          }
          this.resetForm()
        }).catch(e => {
          this.submitLoading = false
          this.alertImportError('导入失败！', null)
          this.resetForm()
        })
      } else {
        matchTeachers({
          query: this.matchTeachersQuery,
          formData
        }).then(res => {
          this.submitLoading = false
          let data = res.data

          if (res.result === 'true') {
            let totalCnt = 0
            let importCnt = 0
            for (let itemData of res.data.matchTeachers) {
              if (itemData.itemId !== '') {
                totalCnt += itemData.rowCount
                importCnt += (itemData.chargerList.length + itemData.teacherList.length)
              }
            }
            if (totalCnt !== importCnt) {
            // 导入失败
              // this.alertImportError('已批量匹配选择了一些教师，还有一些教师没有匹配上！')
              this.$confirm('已批量匹配选择了一些教师，还有一些教师没有匹配上！', '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '查看未匹配上的老师',
                type: 'warning'
              }).catch(() => {
                this.unMathList = res.data.notMatchTeachers
                this.showUnMathcVisible = true        
              });
            } else {
              // 导入成功
              this.alertImportSuccess(importCnt)
            }
            this.$emit('imported-subject-teachers', res.data.matchTeachers)
          } else {
            console.log('导入失败')
            if (data) {
            // 导入失败
              this.alertImportError('导入遇到问题，请下载问题文档！', data.path)
            } else {
            // 导入失败
              this.alertImportError(res.errorMsg, null)
            }
          }
          this.resetForm()
        }).catch(e => {
          console.log(e);
          this.submitLoading = false
          this.alertImportError('导入失败！', null)
          this.resetForm()
        })
      }
    },
    handleUnMathcClose() {
      this.showUnMathcVisible = false
    },
    cancelDialog () {
      this.$emit('update-visible', false)
    },
    handleClose (done) {
      // 不调用 done, 而应该让父组件去关闭弹窗
      this.$emit('update-visible', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.import-tips {
  margin: 0 auto;
  width: 580px;
  color: #459146;
  padding-left: 30px;
  background: url("~@/assets/image/bell.png") left center no-repeat;
}
.import-dialog-container {
  box-sizing: border-box;
  // border-bottom: 1px solid #E0D8CD;
  width: 520px;
  padding: 45px 0;
  margin: 0 auto;
  display: flex;
  align-items: center;

  .upload-wrapper {
    display: flex;
    align-items: center;
  }

  .button-input-file-wrapper {
    position: relative;
  }

  .button-input-file {
    background: transparent;
    width: 220px;
    height: 30px;
    padding: 0;
    color: #A78C6F;
    overflow: hidden;
    text-overflow: ellipsis;
    position: relative;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 220px;
    height: 30px;
    // visibility: hidden;
    color:transparent;
    border: none;
    background: transparent;
    opacity: 0;
    z-index: 10;
  }

  .import-model {
    box-sizing: border-box;
    width: 150px;
    height: 70px;
    border-left: 1px solid #CADFE4;
    margin-left: 32px;
    padding-top: 44px;
    text-align: center;
    background: url("~@/assets/image/excel.png") center top no-repeat;

    &.model-link {
      color: #478F43;
    }
  }
}
.un-match-dialog /deep/.el-dialog{
  margin-top: 7vh !important;
}
</style>



// WEBPACK FOOTER //
// src/views/exam/task/ImportTeacherDialog.vue